import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  getColor,
  Icons,
  InputField,
  Modal,
  Tooltip,
  Typography,
  useToast,
} from "fds";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useDocumentStore from "../../../redux/dispatcher/useDocumentStore";
import usePolicyStore from "../../../redux/dispatcher/usePolicyStore";
import useWorkgroupStore from "../../../redux/dispatcher/useWorkgroupStore";
import utilsDocs from "../../../shared/utils/docs";
import { DocDetailDto } from "../../../types/files";
import Progress from "../../Prgress";
import useLoginStore from "../../../redux/dispatcher/useLoginStore";
import config from "../../../shared/config/config";
import { nanoid } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import NoAuthPreview from "./NoAuthPreview";
import { handleDocDownload, handleDocPreview } from "../../../shared/utils/api";
import useStartDownload from "../../../shared/hooks/useStartDownload";
import authApi from "../../../redux/api/LoginApi";
import utilsCommon from "../../../shared/utils/common";
import {
  getUserInfoFromLocalStorage,
  getWorkspaceName,
  setRedirectUrl,
} from "../../../shared/utils/auth";
import DocDetailModal from "../../../components/DocDetailModal";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { LoginDto } from "../../../types/auth";
import { useMediaQuery } from "../../../shared/hooks/useMediaQuery";
import i18n from "../../../locales/i18n";
import classNames from "classnames";

const copy = require("clipboard-copy");
dayjs.extend(utc);
dayjs.extend(timezone);

const NewWebusingLink = () => {
  const nowDate = new Date();
  const serverTimezone = -nowDate.getTimezoneOffset() / 60;
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);

  const toast = useToast();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    loginState,
    getFileSimpleInfo,
    getFileUrlFromUid,
    getFileUrlDownloadFromUid,
    getDocHtmlDownload,
  } = useLoginStore();
  const {
    documentState,
    getContentDetail,
    getContentDownload,
    getDocTimeline,
  } = useDocumentStore();
  const { getWorkgroupDetail } = useWorkgroupStore();
  const { getLinkFilePolicy } = usePolicyStore();
  const startDownload = useStartDownload();
  const isMobile = useMediaQuery();
  const url = new URL(window.location.href);

  const [checkIsLogin, changeCheckIsLogin] = useState(false);
  const [mode, changeMode] = useState(url.searchParams.get("mode") ?? "NONE");
  const [err, changeErr] = useState("");
  const [apiTokenAfterPw, changeApiTokenAfterPW] = useState<string>("");
  const [password, changePassword] = useState("");
  const [simpleInfo, changeSimpleFileInfo] = useState({
    contentName: "",
    fileSize: 0,
    master: { userId: "", userName: "" },
  });
  const [hover, setHover] = useState(0);
  const [actionList, changeActionList] = useState<
    ("JOIN" | "VIEW" | "DOWNLOAD" | "GUIDE" | "CLIENT" | "INFO" | "LOGIN")[]
  >([]);
  const [syncId] = useState(loginState.actionInfo.syncId);
  const [documentInfo, changeDocumentInfo] = useState<DocDetailDto>();
  const [actionUrl, changeActionUrl] = useState("");
  const [currStep, changeCurrStep] = useState("BEFORE_START");
  const [fileUrl, changeFileUrl] = useState("");
  const [isPwVisible, togglePWVisible] = useState(false); // 비밀번호 보임, 안보임 처리용
  const [openExtraModal, changeOpenExtraModal] = useState("CLOSE");
  const isExpired = {
    policy:
      !!documentInfo?.documentInfo.myPolicy?.policy?.allowDays &&
      ![9999999999999, -1, 0].includes(
        documentInfo?.documentInfo.myPolicy?.policy?.allowDays
      ) &&
      documentInfo &&
      dayjs(
        documentInfo?.documentInfo.myPolicy?.targetType === "USER"
          ? documentInfo?.documentInfo.myPolicy.policy?.startTime
            ? documentInfo?.documentInfo.myPolicy.policy.startTime
            : undefined
          : documentInfo?.documentInfo?.createTime ?? undefined
      )
        .add(
          documentInfo?.documentInfo.myPolicy?.policy?.allowDays
            ? documentInfo?.documentInfo.myPolicy?.policy?.allowDays - 1
            : 0,
          "day"
        )
        .endOf("day")
        .valueOf() < dayjs().endOf("day").valueOf(),
    link:
      dayjs(loginState.actionInfo.expiredTime).valueOf() <
      dayjs().endOf("day").valueOf(),
  };
  const btnActions = {
    JOIN: {
      title: t("wsLogin.signup"),
      icon: <Icons variant="line" label="preview" />,
      action: () =>
        navigate(
          `${
            process.env.PUBLIC_URL
          }/signup?uniqueId=${window.sessionStorage.getItem(
            "signupRequestUuid"
          )}`
        ),
    },
    VIEW: {
      title: t("file.action.preview"),
      icon: <Icons variant="line" label="preview" />,
      action: () => handleSubmitPreviewButton(),
    },
    DOWNLOAD: {
      title: t("file.action.download"),
      icon: <Icons variant="line" label="preview" />,
      action: () =>
        loginState.actionInfo.authType === "LOGIN"
          ? loginState.actionInfo.urlAction !== "HTMLDOWNLOAD"
            ? handleDocDownload(
                syncId,
                getContentDownload,
                toast,
                t,
                "0",
                simpleInfo.contentName
              )
            : getDocHtmlDownload({
                uid: loginState.actionInfo.uniqueId,
                syncId: syncId,
                revisionNo: loginState.actionInfo.revisionNo.toString(),
                startDownload: startDownload,
              }).then((result: any) => {
                if (result.error) {
                  if (
                    result.error.name &&
                    result.error.name !== "INTERNAL_SERVER_ERROR"
                  ) {
                    toast.toastMsg(nanoid(), result.error.message, "error");
                  } else {
                    toast.toastMsg(
                      nanoid(),
                      t("file.alert.downloadFail"),
                      "error"
                    );
                  }
                }
              })
          : handleDocUnauthDownload(),
    },
    GUIDE: {
      title: t("file.action.viewGuide"),
      icon: <Icons variant="line" label="preview" />,
      action: () => window.open(config.url("/service")),
    },
    CLIENT: {
      title: t("file.link.downloadApp"),
      icon: <Icons variant="line" label="preview" />,
      action: () => navigate(config.url("/downloadClient")),
    },
    INFO: {
      title: t("file.link.fileInfo"),
      icon: <Icons variant="line" label="preview" />,
      action: () => changeOpenExtraModal("DOC_DETAIL_MODAL"),
    },
    LOGIN: {
      title: t("login.title"),
      icon: <Icons variant="line" label="preview" />,
      action: () =>
        loginDto
          ? navigate(
              loginDto?.ecoSystemLicenseStats?.featureAccessType === "LITE"
                ? `${process.env.PUBLIC_URL}/myInbox/received`
                : window.eco.serviceType === "OCI" && getWorkspaceName()
                ? `${process.env.PUBLIC_URL}/${getWorkspaceName()}/home`
                : `${process.env.PUBLIC_URL}/home`
            )
          : navigate(config.url("/login")),
    },
  };
  useEffect(() => {
    setRedirectUrl(window.location.href);

    changeCheckIsLogin(!!loginState.loginInfo);
  }, [loginState.loginInfo]);
  useEffect(() => {
    if (syncId) {
      const authType = loginState?.actionInfo?.authType;
      const urlAction = loginState?.actionInfo?.urlAction;
      if (authType === "LOGIN") {
        handleAfterActionLogin();
        changeCurrStep("ING");
      } else if (!(authType === "PASSWORD" && currStep === "BEFORE_START")) {
        if (["WEBUSING", "DOWNLOAD"].includes(urlAction)) {
          changeActionList(
            urlAction === "DOWNLOAD"
              ? ["LOGIN", "DOWNLOAD", "GUIDE"]
              : ["LOGIN", "VIEW", "GUIDE"]
          );
        } else {
          changeActionList(["LOGIN", "DOWNLOAD", "GUIDE", "VIEW"]);
        }
        changeCurrStep("ING");
      }
      getFileSimpleInfo(syncId).then((resp: any) => {
        if (resp.payload)
          changeSimpleFileInfo({
            contentName: resp.payload?.contentName ?? "",
            fileSize: resp.payload?.fileSize ?? 0,
            master: resp.payload?.master ?? { userId: "", userName: "" },
          });
        if (resp.error) changeCurrStep(resp.error.name);
      });
    }
  }, [syncId]);
  useEffect(() => {
    if (loginDto?.ecoUserInfo?.userType === 3) {
      changeActionList(
        utilsCommon.checkLicenseAvailable("allowWebView") &&
          utilsCommon.checkExtensionAvailable(
            simpleInfo.contentName,
            "fwocExtensions"
          )
          ? ["JOIN", "DOWNLOAD", "GUIDE", "VIEW"]
          : ["JOIN", "DOWNLOAD", "GUIDE"]
      );
    }
  }, [simpleInfo]);
  useEffect(() => {
    changeDocumentInfo(documentState.contentAsideDetail);
  }, [documentState.contentAsideDetail]);
  useEffect(() => {
    if (!documentInfo) return;
    getLinkFilePolicy({
      workgroupId: documentInfo?.documentInfo?.workgroup.workgroupId,
      syncId: documentInfo?.documentInfo?.syncId,
    }).then((resp: any) => {
      if (resp.payload.actionUrl) {
        changeActionUrl(resp.payload.actionUrl);
      }
    });

    if (loginDto?.ecoUserInfo?.userType === 3) {
      changeActionList(
        utilsCommon.checkLicenseAvailable("allowWebView") &&
          utilsCommon.checkExtensionAvailable(
            simpleInfo.contentName,
            "fwocExtensions"
          )
          ? ["JOIN", "DOWNLOAD", "GUIDE", "VIEW"]
          : ["JOIN", "DOWNLOAD", "GUIDE"]
      );
    } //  미리보기 지원 파일만 추가
    else if (
      utilsCommon.checkMenuAvailble("preview", documentInfo.documentInfo)
    ) {
      if (isExpired.policy) {
        changeActionList(["CLIENT", "INFO", "GUIDE"]);
      } else changeActionList(["INFO", "DOWNLOAD", "CLIENT", "VIEW", "GUIDE"]);
    } else {
      changeActionList(["CLIENT", "INFO", "GUIDE", "DOWNLOAD"]);
    }

    getWorkgroupDetail({
      workgroupId: documentInfo?.documentInfo?.workgroup.workgroupId,
    });
  }, [documentInfo?.documentInfo?.syncId]);
  useEffect(() => {
    if (mode === "PREVIEW_SUCCESS") {
      const token = window.sessionStorage.getItem("tempApiToken") ?? undefined;
      getFileUrlFromUid({
        uid: loginState.actionInfo.uniqueId,
        token: token,
      }).then((resp: any) => {
        if (resp?.payload?.accessUrl) {
          changeFileUrl(resp.payload.accessUrl);
        } else {
          const url = window.location.href.split("?mode=PREVIEW_SUCCESS")[0];
          const w = window.open(
            url,
            "_blank",
            "status=no, toolbar=no, location=no, menubar=no, resizable=yes, width=1440, height=720"
          );
          if (!w) {
            window.location.href = url;
          }
        }
      });
    }
  }, [mode]);
  const getX = (index: number, type: "ICON" | "LABEL") => {
    switch (index) {
      case 1:
        return type === "ICON" ? "994" : "1006";
      case 2:
      case 3:
        return type === "ICON" ? "882" : "894";
      case 4:
      case 5:
        return type === "ICON" ? "770" : "782";
      case 6:
        return type === "ICON" ? "93" : "102";
      case 7:
        return type === "ICON" ? "256" : "265";
      case 8:
        return type === "ICON" ? "174" : "183";
      default:
        return "0";
    }
  };

  const getY = (index: number, type: "ICON" | "LABEL") => {
    switch (index) {
      case 1:
        return type === "ICON" ? "224" : "266";
      case 2:
        return type === "ICON" ? "156" : "196";
      case 3:
        return type === "ICON" ? "292" : "332";
      case 4:
        return type === "ICON" ? "88" : "128";
      case 5:
        return type === "ICON" ? "360" : "400";
      case 6:
      case 7:
      case 8:
        return type === "ICON" ? "355" : "393";

      default:
        return "0";
    }
  };
  const handleAfterActionLogin = async () => {
    let resp: any = await getContentDetail({
      workgroupId: "NONE",
      syncId,
      type: "aside",
    });
    if (resp.payload) {
      getDocTimeline({
        workgroupId: "NONE",
        syncId,
      });
    }
  };
  const handleDocUnauthDownload = () => {
    const urlAction = loginState.actionInfo.urlAction;
    urlAction !== "HTMLDOWNLOAD"
      ? getFileUrlDownloadFromUid({
          uid: loginState.actionInfo.uniqueId,
          token: apiTokenAfterPw,
        }).then((result: any) => {
          if (result.error) {
            if (
              result.error.name &&
              result.error.name !== "INTERNAL_SERVER_ERROR"
            ) {
              toast.toastMsg(nanoid(), result.error.message, "error");
            } else {
              toast.toastMsg(nanoid(), t("file.alert.downloadFail"), "error");
            }
          }
        })
      : getDocHtmlDownload({
          uid: loginState.actionInfo.uniqueId,
          syncId: syncId,
          revisionNo: loginState.actionInfo.revisionNo.toString(),
          startDownload: startDownload,
        }).then((result: any) => {
          if (result.error) {
            if (
              result.error.name &&
              result.error.name !== "INTERNAL_SERVER_ERROR"
            ) {
              toast.toastMsg(nanoid(), result.error.message, "error");
            } else {
              toast.toastMsg(nanoid(), t("file.alert.downloadFail"), "error");
            }
          }
        });
  };
  /** 비로그인 미리보기 상태 */
  const handleDoActionByUid = async (token?: string): Promise<void> => {
    if (!loginState.actionInfo) return;
    if (loginState.actionInfo.expiredTime < dayjs().valueOf()) {
      changeCurrStep("EXPIRED");
    }
    let resp: any = await getFileUrlFromUid({
      uid: loginState.actionInfo.uniqueId,
      token,
    });
    if (resp.error) {
      switch (resp.error.name) {
        case "DELETED":
          changeCurrStep("DELETED");
          toast.toastMsg(nanoid(), t("file.alert.contentDelete"), "error");
          break;
        case "NO_SELECTED_WEB_OFFICE":
          changeCurrStep("FAIL");
          toast.toastMsg(
            nanoid(),
            t("login.link.alert.noSelectedWebOffice"),
            "error"
          );
          break;
        case "NOT_ALLOW_WEBVIEW":
          changeOpenExtraModal("INVALID_WEB_VIEW");
          break;
        default:
          changeCurrStep("FAIL");
          toast.toastMsg(
            nanoid(),
            resp.error?.message ?? t("file.alert.previewFail"),
            "error"
          );
          break;
      }
    } else {
      // if (currStep.includes("SUCCESS")) {
      if (currStep !== "BEFORE_START") {
        const url = window.location.href + "?mode=PREVIEW_SUCCESS";
        const w = window.open(
          url,
          "_blank",
          "status=no, toolbar=no, location=no, menubar=no, resizable=yes, width=1440, height=720"
        );
        if (!w) window.location.href = url;
      } else {
        changeCurrStep("PREVIEW_SUCCESS");
      }
    }
  };
  const handleSubmitPreviewButton = async () => {
    if (loginState.actionInfo.authType !== "LOGIN") {
      handleDoActionByUid(apiTokenAfterPw);
      return;
    }
    let resp: any = await getContentDetail({
      workgroupId: "NONE",
      syncId,
      type: "aside",
    });
    const myPolicy = resp.payload?.documentInfo?.myPolicy?.policy;
    if (loginState.actionInfo.authType === "LOGIN") {
      // 열람 횟수 초과
      if (
        myPolicy &&
        myPolicy?.allowViewCount > 0 &&
        myPolicy?.currentViewCount >= myPolicy?.allowViewCount
      )
        changeOpenExtraModal("OVER_VIEW_COUNT");
      else if (myPolicy && !myPolicy?.webView) {
        // 미리보기 제한
        changeOpenExtraModal("INVALID_WEB_VIEW");
      } else {
        handleDocPreview({
          permission: "view",
          workgroupId:
            documentState?.contentAsideDetail?.documentInfo?.workgroup
              ?.workgroupId ?? "NONEWORKGROUP",
          syncId: syncId,
          toast,
          t,
          revisionNo: 0,
          uniqueId: loginState.actionInfo.uniqueId,
        });
      }
    } else {
      handleDoActionByUid(apiTokenAfterPw);
    }
  };
  const textLabel = (x: string, y: string, color: string, label: string) => {
    return (
      <text
        x={x}
        y={y}
        fontSize={isMobile ? "11" : "14"}
        fill={color}
        textAnchor="middle"
        fontWeight={700}
      >
        {label}
      </text>
    );
  };

  const getIcon = (
    x: string,
    y: string,
    color: string,
    type: "JOIN" | "VIEW" | "DOWNLOAD" | "GUIDE" | "CLIENT" | "INFO" | "LOGIN"
  ) => {
    return type === "JOIN" ? (
      <svg
        x={x}
        y={y}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.86412 1.19995C5.6975 1.19995 3.94111 2.95634 3.94111 5.12296C3.94111 7.28958 5.6975 9.04597 7.86412 9.04597C10.0307 9.04597 11.7871 7.28958 11.7871 5.12296C11.7871 2.95634 10.0307 1.19995 7.86412 1.19995ZM5.54111 5.12296C5.54111 3.84 6.58116 2.79995 7.86412 2.79995C9.14708 2.79995 10.1871 3.84 10.1871 5.12296C10.1871 6.40592 9.14708 7.44597 7.86412 7.44597C6.58116 7.44597 5.54111 6.40592 5.54111 5.12296Z"
          fill={color}
        />
        <path
          d="M10.3582 18.8007C11.3481 18.8007 12.2697 18.3941 12.9317 17.7132C13.2397 17.3964 13.2326 16.8899 12.9158 16.5819C12.599 16.2739 12.0926 16.2811 11.7846 16.5979C11.4171 16.9758 10.9064 17.2007 10.3582 17.2007H5.36965C4.54702 17.2007 3.8093 16.6941 3.51379 15.9264L2.95583 14.4768C2.45443 13.1742 3.41591 11.7739 4.81169 11.7739H7.86318C8.30501 11.7739 8.66318 11.4157 8.66318 10.9739C8.66318 10.5321 8.30501 10.1739 7.86318 10.1739L4.81169 10.1739C2.29289 10.1739 0.557809 12.7009 1.46262 15.0516L2.02059 16.5012C2.55386 17.8866 3.88513 18.8007 5.36965 18.8007H10.3582Z"
          fill={color}
        />
        <path
          d="M14.6056 6.32446C15.0474 6.32446 15.4056 6.68264 15.4056 7.12446V9.69568H17.9767C18.4186 9.69568 18.7767 10.0539 18.7767 10.4957C18.7767 10.9375 18.4186 11.2957 17.9767 11.2957H15.4056V13.8669C15.4056 14.3087 15.0474 14.6669 14.6056 14.6669C14.1638 14.6669 13.8056 14.3087 13.8056 13.8669V11.2957H11.2343C10.7924 11.2957 10.4343 10.9375 10.4343 10.4957C10.4343 10.0539 10.7924 9.69568 11.2343 9.69568H13.8056V7.12446C13.8056 6.68264 14.1638 6.32446 14.6056 6.32446Z"
          fill={color}
        />
      </svg>
    ) : type === "VIEW" ? (
      <Icons
        variant="line"
        isOn
        label="preview"
        stroke={color}
        location={{ x: x, y: y }}
      />
    ) : type === "DOWNLOAD" ? (
      <Icons
        variant="line"
        label="download"
        stroke={color}
        location={{ x: x, y: y }}
      />
    ) : type === "GUIDE" ? (
      <Icons
        variant="line"
        label="detailInfo"
        stroke={color}
        location={{ x: x, y: y }}
      />
    ) : type === "CLIENT" ? (
      <svg
        x={x}
        y={y}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.7305 2.44995C18.0715 2.45011 19 3.64815 19 4.91772V15.0789C19 16.3484 18.0715 17.5465 16.7305 17.5466H3.26953C1.92847 17.5465 1 16.3484 1 15.0789V4.91772C1 3.64815 1.92847 2.45011 3.26953 2.44995H16.7305ZM2.54883 15.0789C2.54883 15.6797 2.95877 15.9986 3.26953 15.9988H16.7305C17.0412 15.9986 17.4512 15.6797 17.4512 15.0789V9.15991H2.54883V15.0789ZM3.26953 3.99878C2.95877 3.99896 2.54883 4.31691 2.54883 4.91772V7.61108H17.4512V4.91772C17.4512 4.31691 17.0412 3.99896 16.7305 3.99878H3.26953ZM9.5166 4.96558C10.0508 4.96578 10.4841 5.39921 10.4844 5.93335C10.4844 6.46769 10.0509 6.90092 9.5166 6.90112C8.98213 6.90112 8.54883 6.46782 8.54883 5.93335C8.54907 5.39909 8.98228 4.96558 9.5166 4.96558ZM12.4199 4.96558C12.954 4.96581 13.3875 5.39923 13.3877 5.93335C13.3877 6.46768 12.9542 6.90089 12.4199 6.90112C11.8855 6.90112 11.4521 6.46782 11.4521 5.93335C11.4524 5.39909 11.8856 4.96558 12.4199 4.96558ZM15.3223 4.96655C15.8567 4.96655 16.29 5.39986 16.29 5.93433C16.2898 6.46858 15.8566 6.90112 15.3223 6.90112C14.7881 6.90099 14.3547 6.46849 14.3545 5.93433C14.3545 5.39994 14.7879 4.96669 15.3223 4.96655Z"
          fill={color}
        />
      </svg>
    ) : type === "INFO" ? (
      <svg
        x={x}
        y={y}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0003 9.21165C10.4357 9.21165 10.7887 9.5646 10.7887 9.99998V13.2847C10.7887 13.7201 10.4357 14.0731 10.0003 14.0731C9.56496 14.0731 9.21201 13.7201 9.21201 13.2847V9.99998C9.21201 9.5646 9.56496 9.21165 10.0003 9.21165Z"
          fill={color}
        />
        <path
          d="M10.0003 5.92711C9.56496 5.92711 9.21201 6.28006 9.21201 6.71545C9.21201 7.15083 9.56496 7.50378 10.0003 7.50378H10.0086C10.4439 7.50378 10.7969 7.15083 10.7969 6.71545C10.7969 6.28006 10.4439 5.92711 10.0086 5.92711H10.0003Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1 10.0002C1 5.02952 5.02952 1 10.0002 1C14.9708 1 19.0004 5.02952 19.0004 10.0002C19.0004 14.9708 14.9708 19.0004 10.0002 19.0004C5.02952 19.0004 1 14.9708 1 10.0002ZM10.0002 2.57667C5.90029 2.57667 2.57667 5.90029 2.57667 10.0002C2.57667 14.1001 5.90029 17.4237 10.0002 17.4237C14.1001 17.4237 17.4237 14.1001 17.4237 10.0002C17.4237 5.90029 14.1001 2.57667 10.0002 2.57667Z"
          fill={color}
        />
      </svg>
    ) : type === "LOGIN" ? (
      <Icons
        variant={"line"}
        label={"exit"}
        stroke={color}
        location={{ x: x, y: y }}
      />
    ) : (
      <></>
    );
  };
  const handleCheckPassword = async () => {
    authApi
      .checkFilePWValid({
        uuid: loginState.actionInfo.uniqueId,
        password,
      })
      .then((resp) => {
        if (loginState.actionInfo.expiredTime < dayjs().valueOf()) {
          changeCurrStep("EXPIRED");
        } else if (loginState.actionInfo.urlAction.includes("WEBUSING")) {
          window.sessionStorage.setItem("tempApiToken", resp.apiToken);
          changeApiTokenAfterPW(resp.apiToken);
          // handleDoActionByUid(resp.apiToken);
          // if (loginState.actionInfo.expiredTime < dayjs().valueOf()) {
          //   changeCurrStep("EXPIRED");
          // } else {
          changeCurrStep("PREVIEW_SUCCESS");
          // }
        } else {
          window.sessionStorage.setItem("tempApiToken", resp.apiToken);
          changeApiTokenAfterPW(resp.apiToken);
          changeCurrStep("SUCCESS");
        }

        changeActionList(
          loginState.actionInfo.urlAction === "DOWNLOAD"
            ? ["LOGIN", "DOWNLOAD", "GUIDE"]
            : loginState.actionInfo.urlAction === "WEBUSING"
            ? ["LOGIN", "VIEW", "GUIDE"]
            : ["LOGIN", "DOWNLOAD", "GUIDE", "VIEW"]
        );

        changeErr("");
      })
      .catch((err) => {
        if (err.name === "INVALIED_PASSWORD") {
          changeErr("INVALIED_PASSWORD");
        }
      });
  };
  const renderCheckPassword = () => {
    return (
      <Box height={"100%"} width={"100%"} direction="column">
        <Box classes="error-header">
          <img
            src={utilsCommon.renderWrapsodyECOLogo()}
            alt={"logo"}
            height={46}
            className="cursor pointer"
            onClick={() =>
              navigate(
                loginDto?.ecoSystemLicenseStats?.featureAccessType === "LITE"
                  ? `${process.env.PUBLIC_URL}/myInbox/received`
                  : `${process.env.PUBLIC_URL}/home`
              )
            }
          />
        </Box>
        <Box alignItems="center" classes="check_password" direction="column">
          <img
            src={require("../../../shared/images/common/restrictClient.png")}
            alt={"error"}
          />
          <Typography
            type="h2"
            classes="mg mt-10"
            whiteSpace="break-spaces"
            textAlign="center"
          >
            {t("login.login.passwordPlaceholder")}
          </Typography>
          <Typography
            type="body1_md"
            classes="mg mt-26"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
            style={{ marginTop: 26 }}
            whiteSpace="break-spaces"
            textAlign="center"
          >
            {t("login.link.enterPW", { 0: simpleInfo.contentName })}
          </Typography>
          <InputField
            placeholder={t("signup.passwordPlaceholder")}
            size="md"
            width={360}
            style={{ marginTop: 45 }}
            onChange={(e) => changePassword(e.target.value)}
            maxLength={4}
            type={isPwVisible ? "text" : "password"}
            helpMessage={
              err ? t("login.changePW.alert.notMatchPwMsg") : undefined
            }
            isError={err !== ""}
            onKeyUp={(e) => {
              if (e.key === "Enter") handleCheckPassword();
            }}
            trailingIcon={
              <Box alignItems={"center"}>
                <Tooltip
                  message={
                    isPwVisible
                      ? t("login.login.hidePW")
                      : t("login.login.showPW")
                  }
                >
                  <span
                    className={"cursor pointer"}
                    onClick={() => togglePWVisible(!isPwVisible)}
                  >
                    <Icons
                      variant="line"
                      label="preview"
                      isOn={!isPwVisible}
                      stroke={"#717985"}
                    />
                  </span>
                </Tooltip>
              </Box>
            }
          />
          <Button
            label={t("common.confirm")}
            btnStyle="fill"
            width={"360px"}
            classes="mg mt-40"
            state={password === "" ? "disable" : "default"}
            onClick={handleCheckPassword}
          />
        </Box>
      </Box>
    );
  };
  const handleCopyLink = () => {
    copy(window.location.origin);
    toast.toastMsg(nanoid(), t("file.link.siteUrlCopySuccess"), "success");
  };
  return mode === "PREVIEW_SUCCESS" ? (
    <NoAuthPreview
      uniqueId={loginState.actionInfo.uniqueId}
      urlAction={loginState.actionInfo.urlAction}
      syncId={loginState.actionInfo.syncId}
      webviewStatus={currStep}
      accessUrl={fileUrl}
      otp={apiTokenAfterPw}
    />
  ) : loginState.actionInfo?.authType === "PASSWORD" &&
    currStep === "BEFORE_START" ? (
    renderCheckPassword()
  ) : (loginState.actionInfo.authType === "LOGIN" &&
      checkIsLogin &&
      documentInfo?.documentInfo &&
      !documentInfo?.documentInfo?.myPolicy) ||
    currStep === "DELETED" ? (
    <Box
      width={"100%"}
      height={"100%"}
      alignItems="center"
      justifyContent="center"
    >
      <Box
        direction="column"
        minWidth={360}
        justifyContent="center"
        alignItems="center"
      >
        <img src={utilsCommon.renderWrapsodyECOLogo()} width={136} alt="logo" />
        <img
          src={require(currStep === "DELETED"
            ? "../../../shared/images/pages/File/trash.png"
            : "../../../shared/images/common/restrictClient.png")}
          style={{ marginTop: "20px" }}
        />
        <Typography type="h2" classes="mg mt-20">
          {currStep === "DELETED"
            ? t("login.link.deleteFile")
            : t("login.link.noAuth")}
        </Typography>
        <Typography
          type="body1_md"
          classes="mg mt-8"
          whiteSpace="break-spaces"
          exactColor={getColor("COLOR_TEXT_SECONDARY")}
          textAlign="center"
        >
          {currStep === "DELETED"
            ? t("login.link.deleteFileDesc")
            : t("login.link.noAuthDesc")}
        </Typography>
        <Button
          label={t("login.link.goHome")}
          classes="mg mt-40"
          width={"100%"}
          style={{ minWidth: "125px", height: "48px" }}
          btnStyle="fill"
          onClick={() =>
            navigate(
              utilsCommon.renderProperNavigatePath(
                loginDto?.ecoSystemLicenseStats?.featureAccessType === "LITE"
                  ? `/myInbox/received`
                  : "/home"
              )
            )
          }
        />
      </Box>
    </Box>
  ) : !!simpleInfo.contentName ? (
    <Box classes="docDetailModal">
      {openExtraModal === "DOC_DETAIL_MODAL" && (
        <DocDetailModal
          documentInfo={documentInfo}
          open
          actionUrl={actionUrl}
          onClose={() => changeOpenExtraModal("CLOSE")}
        />
      )}
      {openExtraModal === "OVER_VIEW_COUNT" && (
        <Modal
          open
          isMobile={isMobile}
          width={540}
          onClose={() => changeOpenExtraModal("CLOSE")}
          title={t("file.link.viewLimitExceeded")}
          bodyMsg={t("file.link.viewLimitExceededDesc")}
          footer={
            isMobile ? (
              <Box
                width="100%"
                alignItems="center"
                justifyContent="center"
                onClick={() => changeOpenExtraModal("CLOSE")}
              >
                <Typography
                  textAlign="center"
                  type="body1_md"
                  exactColor={getColor("COLOR_TEXT_BRAND")}
                >
                  {t("common.confirm")}
                </Typography>
              </Box>
            ) : (
              <Box>
                <Button
                  label={t("common.confirm")}
                  btnStyle="fill"
                  onClick={() => changeOpenExtraModal("CLOSE")}
                />
              </Box>
            )
          }
        />
      )}
      {openExtraModal === "INVALID_WEB_VIEW" && (
        <Modal
          open
          width={540}
          isMobile={isMobile}
          onClose={() => changeOpenExtraModal("CLOSE")}
          title={t("file.link.previewUnavailable")}
          bodyMsg={t("file.link.previewUnavailableDesc")}
          footer={
            isMobile ? (
              <Box
                width="100%"
                alignItems="center"
                justifyContent="center"
                onClick={() => {
                  changeOpenExtraModal("CLOSE");
                }}
              >
                <Typography
                  textAlign="center"
                  type="body1_md"
                  exactColor={getColor("COLOR_TEXT_BRAND")}
                >
                  {t("common.confirm")}
                </Typography>
              </Box>
            ) : (
              <Box>
                <Button
                  label={t("common.confirm")}
                  btnStyle="fill"
                  onClick={() => changeOpenExtraModal("CLOSE")}
                />
              </Box>
            )
          }
        />
      )}
      <Box classes="docDetailModal-body desktop">
        <Button
          btnStyle="round"
          label={t("login.link.goHome")}
          style={{ position: "absolute", insetInlineEnd: "56px", top: "40px" }}
          trailingIcon={
            <Icons variant="line" label="arrow" direction="right" />
          }
          onClick={() =>
            navigate(
              utilsCommon.renderProperNavigatePath(
                loginDto?.ecoSystemLicenseStats?.featureAccessType === "LITE"
                  ? `/myInbox/received`
                  : "/home"
              )
            )
          }
        />
        <Box classes="docDetailModal-body-logo">
          <img src={require("../../../shared/images/logo/fasoo.png")} />
        </Box>
        <Box classes="docDetailModal-body-detail">
          <svg
            width={actionList?.length > 0 ? "1105" : "904"}
            height="521"
            viewBox={actionList?.length > 0 ? "0 0 1105 521" : "0 0 904 521"}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter_id_0_0)">
              <rect
                width="498.176"
                height="498.176"
                rx="5"
                transform="matrix(0.866025 -0.5 0.866025 0.5 10 260.518)"
                fill="white"
              />
            </g>
            <rect
              width="498.176"
              height="498.176"
              rx="32"
              transform="matrix(0.866025 -0.5 0.866025 0.5 10 246.088)"
              fill="white"
            />
            {/* 1 */}
            {actionList?.length > 0 && (
              <g filter="url(#filter_id_1_0)">
                <rect
                  width="104"
                  height="104"
                  rx="5"
                  transform="matrix(0.866025 -0.5 0.866025 0.5 917.732 259)"
                  fill="white"
                />
              </g>
            )}
            {actionList?.length > 0 && (
              <g
                filter="url(#filter_id_1_1)"
                onMouseEnter={(e) => setHover(1)}
                onMouseLeave={(e) => setHover(0)}
                className="docDetailModal-body-hand"
                onClick={btnActions[actionList[0]].action}
              >
                <rect
                  width="104"
                  height="104"
                  rx="5"
                  transform="matrix(0.866025 -0.5 0.866025 0.5 917.732 246)"
                  fill={hover === 1 ? "#05C072" : "white"}
                />
                {getIcon(
                  getX(1, "ICON"),
                  getY(1, "ICON"),
                  hover === 1
                    ? "white"
                    : getColor("COLOR_ICON_INTERACTIVE_BRAND_DISABLED"),
                  actionList[0]
                )}
                {textLabel(
                  getX(1, "LABEL"),
                  getY(1, "LABEL"),
                  hover === 1 ? "white" : getColor("COLOR_TEXT_PRIMARY"),
                  btnActions[actionList[0]].title
                )}
              </g>
            )}
            {/* 2 */}
            {actionList?.length > 1 && (
              <g filter="url(#filter_id_2_0)">
                <rect
                  width="104"
                  height="104"
                  rx="5"
                  transform="matrix(0.866025 -0.5 0.866025 0.5 803.732 191)"
                  fill="white"
                />
              </g>
            )}
            {actionList?.length > 1 && (
              <g
                filter="url(#filter_id_2_1)"
                onMouseEnter={(e) => setHover(2)}
                onMouseLeave={(e) => setHover(0)}
                onClick={btnActions[actionList[1]].action}
                className="docDetailModal-body-hand"
              >
                <rect
                  width="104"
                  height="104"
                  rx="5"
                  transform="matrix(0.866025 -0.5 0.866025 0.5 803.732 178)"
                  fill={hover === 2 ? "#05C072" : "white"}
                />
                {getIcon(
                  getX(2, "ICON"),
                  getY(2, "ICON"),
                  hover === 2
                    ? "white"
                    : getColor("COLOR_ICON_INTERACTIVE_BRAND_DISABLED"),
                  actionList[1]
                )}
                {textLabel(
                  getX(2, "LABEL"),
                  getY(2, "LABEL"),
                  hover === 2 ? "white" : getColor("COLOR_TEXT_PRIMARY"),
                  btnActions[actionList[1]].title
                )}
              </g>
            )}
            {/* 3 */}
            {actionList?.length > 2 && (
              <g filter="url(#filter_id_3_0)">
                <rect
                  width="104"
                  height="104"
                  rx="5"
                  transform="matrix(0.866025 -0.5 0.866025 0.5 803.732 326)"
                  fill="white"
                />
              </g>
            )}
            {actionList?.length > 2 && (
              <g
                filter="url(#filter_id_3_1)"
                onMouseEnter={(e) => setHover(3)}
                onMouseLeave={(e) => setHover(0)}
                onClick={btnActions[actionList[2]].action}
                className="docDetailModal-body-hand"
              >
                <rect
                  width="104"
                  height="104"
                  rx="5"
                  transform="matrix(0.866025 -0.5 0.866025 0.5 803.732 313)"
                  fill={hover === 3 ? "#05C072" : "white"}
                />
                {getIcon(
                  getX(3, "ICON"),
                  getY(3, "ICON"),
                  hover === 3
                    ? "white"
                    : getColor("COLOR_ICON_INTERACTIVE_BRAND_DISABLED"),
                  actionList[2]
                )}
                {textLabel(
                  getX(3, "LABEL"),
                  getY(3, "LABEL"),
                  hover === 3 ? "white" : getColor("COLOR_TEXT_PRIMARY"),
                  btnActions[actionList[2]].title
                )}
              </g>
            )}
            {/* 4 */}
            {actionList?.length > 3 && (
              <g filter="url(#filter_id_4_0)">
                <rect
                  width="104"
                  height="104"
                  rx="5"
                  transform="matrix(0.866025 -0.5 0.866025 0.5 689.732 123)"
                  fill="white"
                />
              </g>
            )}
            {actionList?.length > 3 && (
              <g
                filter="url(#filter_id_4_1)"
                onMouseEnter={(e) => setHover(4)}
                onMouseLeave={(e) => setHover(0)}
                onClick={btnActions[actionList[3]].action}
                className="docDetailModal-body-hand"
              >
                <rect
                  width="104"
                  height="104"
                  rx="5"
                  transform="matrix(0.866025 -0.5 0.866025 0.5 689.732 110)"
                  fill={hover === 4 ? "#05C072" : "white"}
                />
                {getIcon(
                  getX(4, "ICON"),
                  getY(4, "ICON"),
                  hover === 4
                    ? "white"
                    : getColor("COLOR_ICON_INTERACTIVE_BRAND_DISABLED"),
                  actionList[3]
                )}
                {textLabel(
                  getX(4, "LABEL"),
                  getY(4, "LABEL"),
                  hover === 4 ? "white" : getColor("COLOR_TEXT_PRIMARY"),
                  btnActions[actionList[3]].title
                )}
              </g>
            )}
            {/* 5 */}
            {actionList?.length > 4 && (
              <g filter="url(#filter_id_5_0)">
                <rect
                  width="104"
                  height="104"
                  rx="5"
                  transform="matrix(0.866025 -0.5 0.866025 0.5 689.732 396)"
                  fill="white"
                />
              </g>
            )}
            {actionList?.length > 4 && (
              <g
                filter="url(#filter_id_5_1)"
                onMouseEnter={(e) => setHover(5)}
                onMouseLeave={(e) => setHover(0)}
                onClick={btnActions[actionList[4]].action}
                className="docDetailModal-body-hand"
              >
                <rect
                  width="104"
                  height="104"
                  rx="5"
                  transform="matrix(0.866025 -0.5 0.866025 0.5 689.732 383)"
                  fill={hover === 5 ? "#05C072" : "white"}
                />
                {getIcon(
                  getX(5, "ICON"),
                  getY(5, "ICON"),
                  hover === 5
                    ? "white"
                    : getColor("COLOR_ICON_INTERACTIVE_BRAND_DISABLED"),
                  actionList[4]
                )}
                {textLabel(
                  getX(5, "LABEL"),
                  getY(5, "LABEL"),
                  hover === 5 ? "white" : getColor("COLOR_TEXT_PRIMARY"),
                  btnActions[actionList[4]].title
                )}
              </g>
            )}
            <path
              d="M25.4253 237.169L26.1411 255.394L236.051 376.586L276.196 353.408L182.118 299.092L179.433 297.542L157.081 284.637L143.644 276.879L140.959 275.329L88.6096 245.105L85.9241 243.555L88.4905 242.073L184.473 186.657L148.694 166L25.4253 237.169Z"
              fill="url(#paint0_linear_0_1)"
              fill-opacity={hover > 0 ? "1" : "0.25"}
            />
            <path
              d="M426.269 487.68L457.835 487.266L667.745 366.075L627.6 342.897L533.523 397.213L530.837 398.763L508.486 411.668L495.049 419.426L492.363 420.976L440.014 451.2L437.328 452.751L434.762 451.269L338.779 395.853L303 416.51L426.269 487.68Z"
              fill="url(#paint1_linear_0_1)"
              fill-opacity={hover > 0 ? "1" : "0.25"}
            />
            <path
              d="M456.476 5.9058L424.91 6.31909L215 127.51L255.145 150.688L349.223 96.3725L351.908 94.822L374.26 81.9174L387.697 74.1595L390.382 72.6091L442.731 42.3853L445.417 40.8348L447.983 42.3165L543.966 97.7321L579.745 77.075L456.476 5.9058Z"
              fill="url(#paint2_linear_0_1)"
              fill-opacity={hover > 0 ? "1" : "0.25"}
            />
            <path
              d="M858.319 255.417L857.603 237.192L647.694 116L607.549 139.178L701.626 193.494L704.312 195.044L726.663 207.949L740.1 215.707L742.785 217.257L795.135 247.481L797.82 249.031L795.254 250.513L699.271 305.929L735.05 326.586L858.319 255.417Z"
              fill="url(#paint3_linear_0_1)"
              fill-opacity={hover > 0 ? "1" : "0.25"}
            />
            <defs>
              <filter
                id="filter_id_0_0"
                x="0.536133"
                y="0.894043"
                width="881.793"
                height="519.247"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="6" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0196078 0 0 0 0 0.752941 0 0 0 0 0.447059 0 0 0 0.5 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_0_1"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_0_1"
                  result="shape"
                />
              </filter>
              <filter
                id="filter_id_1_0"
                x="911.269"
                y="199.464"
                width="193.061"
                height="119.071"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="4.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0196078 0 0 0 0 0.752941 0 0 0 0 0.447059 0 0 0 0.5 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_0_1"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_0_1"
                  result="shape"
                />
              </filter>
              <filter
                id="filter_id_1_1"
                x="911.269"
                y="186.464"
                width="193.061"
                height="119.071"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="4.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0196078 0 0 0 0 0.752941 0 0 0 0 0.447059 0 0 0 0.5 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_0_1"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_0_1"
                  result="shape"
                />
              </filter>
              <filter
                id="filter_id_2_0"
                x="797.269"
                y="131.464"
                width="193.061"
                height="119.071"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="4.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0196078 0 0 0 0 0.752941 0 0 0 0 0.447059 0 0 0 0.5 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_0_1"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_0_1"
                  result="shape"
                />
              </filter>
              <filter
                id="filter_id_2_1"
                x="797.269"
                y="118.464"
                width="193.061"
                height="119.071"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="4.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0196078 0 0 0 0 0.752941 0 0 0 0 0.447059 0 0 0 0.5 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_0_1"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_0_1"
                  result="shape"
                />
              </filter>
              <filter
                id="filter_id_3_0"
                x="797.269"
                y="266.464"
                width="193.061"
                height="119.071"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="4.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0196078 0 0 0 0 0.752941 0 0 0 0 0.447059 0 0 0 0.5 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_0_1"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_0_1"
                  result="shape"
                />
              </filter>
              <filter
                id="filter_id_3_1"
                x="797.269"
                y="253.464"
                width="193.061"
                height="119.071"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="4.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0196078 0 0 0 0 0.752941 0 0 0 0 0.447059 0 0 0 0.5 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_0_1"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_0_1"
                  result="shape"
                />
              </filter>
              <filter
                id="filter_id_4_0"
                x="683.269"
                y="63.4644"
                width="193.061"
                height="119.071"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="4.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0196078 0 0 0 0 0.752941 0 0 0 0 0.447059 0 0 0 0.5 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_0_1"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_0_1"
                  result="shape"
                />
              </filter>
              <filter
                id="filter_id_4_1"
                x="683.269"
                y="50.4644"
                width="193.061"
                height="119.071"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="4.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0196078 0 0 0 0 0.752941 0 0 0 0 0.447059 0 0 0 0.5 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_0_1"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_0_1"
                  result="shape"
                />
              </filter>
              <filter
                id="filter_id_5_0"
                x="683.269"
                y="336.464"
                width="193.061"
                height="119.071"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="4.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0196078 0 0 0 0 0.752941 0 0 0 0 0.447059 0 0 0 0.5 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_0_1"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_0_1"
                  result="shape"
                />
              </filter>
              <filter
                id="filter_id_5_1"
                x="683.269"
                y="323.464"
                width="193.061"
                height="119.071"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="4.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0196078 0 0 0 0 0.752941 0 0 0 0 0.447059 0 0 0 0.5 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_0_1"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_0_1"
                  result="shape"
                />
              </filter>

              <linearGradient
                id="paint0_linear_0_1"
                x1="79.347"
                y1="206.038"
                x2="192.372"
                y2="401.803"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#05C072" />
                <stop offset="1" stop-color="white" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_0_1"
                x1="372.347"
                y1="456.548"
                x2="485.373"
                y2="260.782"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#05C072" />
                <stop offset="1" stop-color="white" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_0_1"
                x1="510.398"
                y1="37.0375"
                x2="397.373"
                y2="232.803"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#05C072" />
                <stop offset="1" stop-color="white" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_0_1"
                x1="804.397"
                y1="286.548"
                x2="691.372"
                y2="90.7827"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#05C072" />
                <stop offset="1" stop-color="white" />
              </linearGradient>
            </defs>
          </svg>
          <Box
            classes={
              "docDetailModal-outBox docDetailModal-outBox-button"
              // actionList?.length > 0
              //   ? "docDetailModal-outBox docDetailModal-outBox-button"
              //   : "docDetailModal-outBox"
            }
          >
            <Box classes="docDetailModal-outBox-in" direction="column">
              <Box justifyContent="center">
                <Tooltip message={simpleInfo?.contentName}>
                  <Typography type="h1" ellipsis>
                    {simpleInfo?.contentName}
                  </Typography>
                </Tooltip>
              </Box>
              <Box justifyContent="center" classes="mg mt-8">
                <Typography
                  type="body2_md"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {utilsDocs.fileSizeFormat(simpleInfo?.fileSize)}
                </Typography>
              </Box>
              <Box classes="mg mt-16" justifyContent="center">
                <Box direction="row" width={292} alignItems="center">
                  {utilsDocs.renderDocIcon(simpleInfo?.contentName, 48)}
                  <Box direction="column" maxWidth={244}>
                    <Box>
                      <Typography
                        type="body3_rg"
                        exactColor={getColor("COLOR_TEXT_SECONDARY")}
                        classes="mg ml-16"
                        style={{ minWidth: 68 }}
                      >
                        {t("file.master")}:
                      </Typography>
                      <Tooltip
                        classes="mg ml-8"
                        message={utilsCommon.getUserNameIdTag(
                          simpleInfo.master.userId,
                          simpleInfo.master.userName
                        )}
                        maxWidth={250}
                      >
                        <Typography type="body2_md" ellipsis>
                          {utilsCommon.getUserNameIdTag(
                            simpleInfo.master.userId,
                            simpleInfo.master.userName
                          )}
                        </Typography>
                      </Tooltip>
                    </Box>
                    {!!documentInfo?.documentInfo.myPolicy?.policy?.allowDays &&
                      ![9999999999999, -1, 0].includes(
                        documentInfo?.documentInfo.myPolicy?.policy?.allowDays
                      ) && (
                        <Box classes="mg mt-8">
                          <Typography
                            type="body3_rg"
                            exactColor={getColor("COLOR_TEXT_SECONDARY")}
                            classes="mg ml-16"
                            whiteSpace="pre"
                            style={{ minWidth: 68 }}
                          >
                            {`${t("file.policy.viewExpiration")}:`}
                          </Typography>

                          <Typography
                            type="body2_md"
                            classes="mg ml-8"
                            whiteSpace="pre"
                            exactColor={
                              isExpired.policy
                                ? getColor("COLOR_TEXT_ERROR")
                                : getColor("COLOR_TEXT_PRIMARY")
                            }
                          >
                            {utilsCommon.renderDateFormat(
                              dayjs(
                                documentInfo?.documentInfo.myPolicy
                                  .targetType === "USER"
                                  ? documentInfo?.documentInfo.myPolicy.policy
                                      ?.startTime
                                    ? documentInfo?.documentInfo.myPolicy.policy
                                        .startTime
                                    : undefined
                                  : documentInfo?.documentInfo?.createTime ??
                                      undefined
                              )
                                .add(
                                  documentInfo?.documentInfo.myPolicy?.policy
                                    ?.allowDays
                                    ? documentInfo?.documentInfo.myPolicy
                                        ?.policy?.allowDays - 1
                                    : 0,
                                  "day"
                                )
                                .set("hour", 23)
                                .set("minute", 59)
                                .valueOf(),
                              "YYYY-MM-DD"
                            )}
                            {` (GMT+${serverTimezone})`}
                            {isExpired.policy && ` (${t("file.expired")})`}
                          </Typography>
                        </Box>
                      )}

                    {loginState.actionInfo.authType !== "LOGIN" &&
                      !!loginState.actionInfo.expiredTime &&
                      ![9999999999999, -1, 0].includes(
                        loginState.actionInfo.expiredTime
                      ) && (
                        <Box classes="mg mt-8" alignItems="center">
                          <Typography
                            type="body3_rg"
                            exactColor={getColor("COLOR_TEXT_SECONDARY")}
                            classes="mg ml-16"
                            whiteSpace={
                              i18n.language.includes("en") ? "normal" : "pre"
                            }
                            width={68}
                            style={{ minWidth: 68 }}
                          >
                            {t("file.linkExpiration")}:
                          </Typography>
                          <Typography
                            type="body2_md"
                            classes="mg ml-8"
                            whiteSpace="pre"
                            exactColor={
                              isExpired.link
                                ? getColor("COLOR_TEXT_ERROR")
                                : getColor("COLOR_TEXT_PRIMARY")
                            }
                          >
                            {utilsCommon.renderDateFormat(
                              dayjs(
                                loginState.actionInfo.expiredTime
                              ).valueOf(),
                              "YYYY-MM-DD",
                              "",
                              true
                            )}
                            {` (GMT+${serverTimezone})`}
                            {isExpired.link && ` (${t("file.expired")})`}
                          </Typography>
                        </Box>
                      )}
                    {loginState.actionInfo.authType === "LOGIN" && (
                      <Box alignItems="center">
                        <Typography
                          type="body3_rg"
                          exactColor={getColor("COLOR_TEXT_SECONDARY")}
                          classes="mg ml-16"
                          style={{ minWidth: 68 }}
                          whiteSpace="pre"
                        >
                          {t("file.policy.siteUrl")}:
                        </Typography>
                        <Tooltip
                          classes="mg ml-8"
                          message={window.location.origin}
                          maxWidth={152}
                        >
                          <Typography type="body2_md" whiteSpace="pre" ellipsis>
                            {window.location.origin}
                          </Typography>
                        </Tooltip>
                        <Button
                          btnStyle="link"
                          label={t("common.copy")}
                          onClick={handleCopyLink}
                          leadingIcon={<Icons variant="line" label="copy" />}
                          whiteSpace="pre"
                        />
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box classes="docDetailModal-body-ci" direction="column">
          <svg
            // width="240"
            height="8vh"
            viewBox="0 0 240 76"
            style={{ maxHeight: 76 }}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M95.5664 58.7578C95.5664 58.3125 95.6758 57.9023 95.8945 57.5273C96.1172 57.1523 96.416 56.8555 96.791 56.6367C97.1699 56.418 97.582 56.3086 98.0273 56.3086C98.4141 56.3086 98.7734 56.3926 99.1055 56.5605C99.4414 56.7246 99.7188 56.9531 99.9375 57.2461C100.156 57.5391 100.293 57.8672 100.348 58.2305H99.3281C99.2891 58.0469 99.2051 57.8828 99.0762 57.7383C98.9512 57.5898 98.7969 57.4746 98.6133 57.3926C98.4297 57.3105 98.2344 57.2695 98.0273 57.2695C97.7578 57.2695 97.5078 57.3359 97.2773 57.4688C97.0508 57.6016 96.8711 57.7832 96.7383 58.0137C96.6055 58.2402 96.5391 58.4883 96.5391 58.7578C96.5391 59.0273 96.6055 59.2773 96.7383 59.5078C96.8711 59.7344 97.0508 59.9141 97.2773 60.0469C97.5078 60.1797 97.7578 60.2461 98.0273 60.2461C98.3359 60.2461 98.6016 60.1582 98.8242 59.9824C99.0469 59.8027 99.1875 59.5703 99.2461 59.2852H100.254C100.203 59.6484 100.074 59.9766 99.8672 60.2695C99.6641 60.5625 99.4023 60.793 99.082 60.9609C98.7617 61.125 98.4102 61.207 98.0273 61.207C97.582 61.207 97.1699 61.0977 96.791 60.8789C96.416 60.6602 96.1172 60.3633 95.8945 59.9883C95.6758 59.6133 95.5664 59.2031 95.5664 58.7578ZM97.9805 63.1289C97.1914 63.1289 96.4609 62.9336 95.7891 62.543C95.1172 62.1484 94.584 61.6172 94.1895 60.9492C93.7988 60.2773 93.6055 59.5469 93.6094 58.7578C93.6094 57.9648 93.8047 57.2344 94.1953 56.5664C94.5898 55.8945 95.1211 55.3633 95.7891 54.9727C96.4609 54.582 97.1914 54.3867 97.9805 54.3867C98.7773 54.3867 99.5098 54.582 100.178 54.9727C100.846 55.3633 101.375 55.8926 101.766 56.5605C102.156 57.2285 102.352 57.9609 102.352 58.7578C102.355 59.5508 102.162 60.2812 101.771 60.9492C101.381 61.6172 100.85 62.1484 100.178 62.543C99.5098 62.9336 98.7773 63.1289 97.9805 63.1289ZM97.9805 62.1562C98.5938 62.1562 99.1602 62.0059 99.6797 61.7051C100.203 61.4004 100.617 60.9902 100.922 60.4746C101.227 59.9551 101.379 59.3906 101.379 58.7812C101.379 58.1602 101.227 57.5879 100.922 57.0645C100.621 56.541 100.209 56.127 99.6855 55.8223C99.166 55.5137 98.5977 55.3594 97.9805 55.3594C97.3672 55.3594 96.7988 55.5137 96.2754 55.8223C95.7559 56.1309 95.3438 56.5488 95.0391 57.0762C94.7344 57.5996 94.582 58.168 94.582 58.7812C94.582 59.3867 94.7344 59.9492 95.0391 60.4688C95.3477 60.9844 95.7617 61.3945 96.2812 61.6992C96.8047 62.0039 97.3711 62.1562 97.9805 62.1562ZM106.91 54.5156H112.02V55.4531H107.965V58.2891H111.633V59.2148H107.965V63H106.91V54.5156ZM113.145 61.1953C113.145 60.5352 113.369 60.0703 113.818 59.8008C114.271 59.5312 114.844 59.3711 115.535 59.3203C115.801 59.3008 116.098 59.2832 116.426 59.2676C116.758 59.248 117.035 59.2344 117.258 59.2266V58.7109C117.258 58.3008 117.135 57.9863 116.889 57.7676C116.646 57.5449 116.289 57.4336 115.816 57.4336C115.43 57.4336 115.113 57.5137 114.867 57.6738C114.621 57.8301 114.461 58.0352 114.387 58.2891H113.332C113.375 57.9492 113.508 57.6484 113.73 57.3867C113.953 57.125 114.248 56.9219 114.615 56.7773C114.986 56.6289 115.402 56.5547 115.863 56.5547C116.473 56.5547 117.023 56.7109 117.516 57.0234C118.008 57.332 118.254 57.9258 118.254 58.8047V63H117.258V62.1328H117.211C117.133 62.2969 117.012 62.457 116.848 62.6133C116.688 62.7656 116.477 62.8945 116.215 63C115.957 63.1016 115.656 63.1523 115.312 63.1523C114.906 63.1523 114.539 63.0742 114.211 62.918C113.883 62.7617 113.623 62.5371 113.432 62.2441C113.24 61.9473 113.145 61.5977 113.145 61.1953ZM114.152 61.2422C114.152 61.5664 114.273 61.8164 114.516 61.9922C114.762 62.1641 115.086 62.25 115.488 62.25C115.852 62.25 116.166 62.1777 116.432 62.0332C116.701 61.8887 116.906 61.6973 117.047 61.459C117.188 61.2207 117.258 60.9648 117.258 60.6914V60.0527L115.652 60.1641C115.176 60.1953 114.807 60.2988 114.545 60.4746C114.283 60.6504 114.152 60.9062 114.152 61.2422ZM123.41 58.2891C123.336 58.0117 123.191 57.7969 122.977 57.6445C122.766 57.4883 122.48 57.4102 122.121 57.4102C121.863 57.4102 121.631 57.4531 121.424 57.5391C121.221 57.6211 121.061 57.7363 120.943 57.8848C120.83 58.0293 120.773 58.1914 120.773 58.3711C120.773 58.582 120.861 58.7617 121.037 58.9102C121.217 59.0586 121.492 59.1758 121.863 59.2617L122.812 59.4961C123.383 59.6328 123.809 59.8438 124.09 60.1289C124.371 60.4102 124.512 60.7734 124.512 61.2188C124.512 61.5898 124.412 61.9199 124.213 62.209C124.018 62.4941 123.732 62.7188 123.357 62.8828C122.982 63.0469 122.535 63.1289 122.016 63.1289C121.301 63.1289 120.734 62.9766 120.316 62.6719C119.898 62.3633 119.648 61.918 119.566 61.3359H120.621C120.68 61.6445 120.822 61.875 121.049 62.0273C121.275 62.1758 121.59 62.25 121.992 62.25C122.445 62.25 122.805 62.1621 123.07 61.9863C123.336 61.8105 123.469 61.5742 123.469 61.2773C123.469 61.0508 123.385 60.8633 123.217 60.7148C123.049 60.5625 122.785 60.4453 122.426 60.3633L121.465 60.1406C120.91 60.0117 120.488 59.8008 120.199 59.5078C119.91 59.2148 119.766 58.8555 119.766 58.4297C119.766 58.0703 119.863 57.748 120.059 57.4629C120.258 57.1777 120.535 56.9551 120.891 56.7949C121.25 56.6348 121.66 56.5547 122.121 56.5547C122.551 56.5547 122.93 56.627 123.258 56.7715C123.586 56.916 123.846 57.1191 124.037 57.3809C124.232 57.6426 124.352 57.9453 124.395 58.2891H123.41ZM128.426 63.1289C127.852 63.1289 127.344 62.9941 126.902 62.7246C126.465 62.4512 126.125 62.0664 125.883 61.5703C125.641 61.0742 125.52 60.5 125.52 59.8477C125.52 59.1953 125.641 58.6211 125.883 58.125C126.125 57.625 126.465 57.2383 126.902 56.9648C127.344 56.6914 127.852 56.5547 128.426 56.5547C128.996 56.5547 129.498 56.6914 129.932 56.9648C130.369 57.2383 130.707 57.625 130.945 58.125C131.188 58.6211 131.309 59.1953 131.309 59.8477C131.309 60.5 131.188 61.0742 130.945 61.5703C130.707 62.0664 130.369 62.4512 129.932 62.7246C129.498 62.9941 128.996 63.1289 128.426 63.1289ZM128.426 62.2383C128.836 62.2383 129.182 62.1309 129.463 61.916C129.744 61.6973 129.953 61.4082 130.09 61.0488C130.23 60.6855 130.301 60.2852 130.301 59.8477C130.301 59.4102 130.23 59.0098 130.09 58.6465C129.953 58.2832 129.744 57.9922 129.463 57.7734C129.182 57.5547 128.836 57.4453 128.426 57.4453C128.008 57.4453 127.656 57.5547 127.371 57.7734C127.09 57.9922 126.879 58.2832 126.738 58.6465C126.598 59.0098 126.527 59.4102 126.527 59.8477C126.527 60.2852 126.598 60.6855 126.738 61.0488C126.879 61.4082 127.09 61.6973 127.371 61.916C127.656 62.1309 128.008 62.2383 128.426 62.2383ZM135.234 63.1289C134.66 63.1289 134.152 62.9941 133.711 62.7246C133.273 62.4512 132.934 62.0664 132.691 61.5703C132.449 61.0742 132.328 60.5 132.328 59.8477C132.328 59.1953 132.449 58.6211 132.691 58.125C132.934 57.625 133.273 57.2383 133.711 56.9648C134.152 56.6914 134.66 56.5547 135.234 56.5547C135.805 56.5547 136.307 56.6914 136.74 56.9648C137.178 57.2383 137.516 57.625 137.754 58.125C137.996 58.6211 138.117 59.1953 138.117 59.8477C138.117 60.5 137.996 61.0742 137.754 61.5703C137.516 62.0664 137.178 62.4512 136.74 62.7246C136.307 62.9941 135.805 63.1289 135.234 63.1289ZM135.234 62.2383C135.645 62.2383 135.99 62.1309 136.271 61.916C136.553 61.6973 136.762 61.4082 136.898 61.0488C137.039 60.6855 137.109 60.2852 137.109 59.8477C137.109 59.4102 137.039 59.0098 136.898 58.6465C136.762 58.2832 136.553 57.9922 136.271 57.7734C135.99 57.5547 135.645 57.4453 135.234 57.4453C134.816 57.4453 134.465 57.5547 134.18 57.7734C133.898 57.9922 133.688 58.2832 133.547 58.6465C133.406 59.0098 133.336 59.4102 133.336 59.8477C133.336 60.2852 133.406 60.6855 133.547 61.0488C133.688 61.4082 133.898 61.6973 134.18 61.916C134.465 62.1309 134.816 62.2383 135.234 62.2383Z"
              fill="#717985"
            />
            <path
              d="M188.902 17.6624H166.73C165.299 17.6624 164.133 16.5022 164.133 15.0648V4.8476C164.133 3.41603 165.293 2.25 166.73 2.25H188.902C190.334 2.25 191.5 3.41026 191.5 4.8476V15.0706C191.5 16.5022 190.334 17.6624 188.902 17.6624Z"
              fill="#7FBA46"
            />
            <path
              d="M170.009 11.7052C170.073 12.4845 170.84 12.8539 171.718 12.8539C172.364 12.8539 172.884 12.7673 173.392 12.6057L173.64 13.8814C173.022 14.1296 172.266 14.2508 171.446 14.2508C169.391 14.2508 168.214 13.0617 168.214 11.1684C168.214 9.63289 169.166 7.93579 171.273 7.93579C173.23 7.93579 173.975 9.45972 173.975 10.9548C173.975 11.278 173.94 11.5609 173.911 11.6994H170.009V11.7052ZM172.226 10.4179C172.226 9.96192 172.029 9.19418 171.158 9.19418C170.367 9.19418 170.044 9.90997 169.992 10.4179H172.226Z"
              fill="white"
            />
            <path
              d="M181.075 13.8929C180.728 14.066 179.949 14.2508 178.933 14.2508C176.047 14.2508 174.563 12.4555 174.563 10.0773C174.563 7.23147 176.595 5.64404 179.124 5.64404C180.099 5.64404 180.844 5.84031 181.179 6.01348L180.792 7.51431C180.411 7.35269 179.874 7.2026 179.205 7.2026C177.704 7.2026 176.543 8.10888 176.543 9.96183C176.543 11.6358 177.536 12.6864 179.216 12.6864C179.788 12.6864 180.417 12.5652 180.786 12.4151L181.075 13.8929Z"
              fill="white"
            />
            <path
              d="M187.418 11.0356C187.418 13.2522 185.848 14.2682 184.22 14.2682C182.448 14.2682 181.086 13.1021 181.086 11.1453C181.086 9.18841 182.373 7.93579 184.318 7.93579C186.183 7.94156 187.418 9.2115 187.418 11.0356ZM183.037 11.0991C183.037 12.1381 183.47 12.9174 184.278 12.9174C185.011 12.9174 185.479 12.1843 185.479 11.0991C185.479 10.1928 185.132 9.28077 184.278 9.28077C183.372 9.275 183.037 10.2044 183.037 11.0991Z"
              fill="white"
            />
            <path
              d="M50.7043 30.8994L46.375 12.6584H50.7851L52.1705 20.1799C52.5746 22.3504 52.9498 24.7055 53.25 26.5469H53.3019C53.5963 24.567 54.0293 22.3735 54.4968 20.128L56.0381 12.6584H60.4251L61.8856 20.3416C62.2954 22.4831 62.5898 24.4342 62.8611 26.4604H62.9131C63.1844 24.4342 63.5884 22.2984 63.9694 20.128L65.4587 12.6584H69.661L64.9507 30.8994H60.4829L58.9416 23.0546C58.5895 21.2132 58.2951 19.5103 58.0757 17.4207H58.0238C57.7005 19.4815 57.4061 21.2132 56.9674 23.0546L55.2357 30.8994H50.7043Z"
              fill="#59595B"
            />
            <path
              d="M70.0648 22.0272C70.0648 20.0761 70.0128 18.8004 69.9551 17.6632H73.5051L73.6379 20.0992H73.7476C74.4229 18.177 76.0508 17.363 77.3265 17.363C77.7017 17.363 77.8922 17.363 78.1924 17.415V21.2883C77.8922 21.2306 77.5458 21.1844 77.084 21.1844C75.5659 21.1844 74.5384 21.9983 74.2671 23.2625C74.2151 23.5338 74.1863 23.8628 74.1863 24.1861V30.8936H70.0705V22.0272H70.0648Z"
              fill="#59595B"
            />
            <path
              d="M86.7193 30.8993L86.4769 29.5774H86.3961C85.5302 30.628 84.1737 31.1994 82.5978 31.1994C79.9251 31.1994 78.3262 29.2541 78.3262 27.1414C78.3262 23.701 81.4144 22.0501 86.0959 22.079V21.8942C86.0959 21.19 85.7149 20.1856 83.683 20.1856C82.3322 20.1856 80.9007 20.6532 80.029 21.19L79.2729 18.5289C80.1964 18.0209 82.009 17.3687 84.4219 17.3687C88.832 17.3687 90.2463 19.972 90.2463 23.0776V27.6782C90.2463 28.9539 90.2982 30.1719 90.431 30.8993H86.7193ZM86.2344 24.6477C84.0698 24.6246 82.3842 25.1326 82.3842 26.7316C82.3842 27.7879 83.0884 28.3017 84.012 28.3017C85.0395 28.3017 85.8823 27.6205 86.1536 26.7835C86.2056 26.5699 86.2344 26.3217 86.2344 26.085V24.6477Z"
              fill="#59595B"
            />
            <path
              d="M92.6243 22.1077C92.6243 20.3759 92.5724 18.8866 92.5146 17.6687H96.0878L96.2783 19.5101H96.3302C97.3058 18.1016 98.8239 17.3743 100.746 17.3743C103.644 17.3743 106.247 19.8911 106.247 24.1107C106.247 28.9307 103.188 31.1993 100.238 31.1993C98.6392 31.1993 97.3981 30.5528 96.8036 29.6811H96.7459V36.2617H92.6301V22.1077H92.6243ZM96.7401 25.219C96.7401 25.548 96.7632 25.8482 96.8209 26.0907C97.0922 27.199 98.0389 28.036 99.2338 28.036C101.017 28.036 102.08 26.5525 102.08 24.3012C102.08 22.1885 101.133 20.5895 99.2915 20.5895C98.1312 20.5895 97.098 21.4612 96.8267 22.6734C96.7747 22.887 96.7459 23.164 96.7459 23.4007V25.219H96.7401Z"
              fill="#59595B"
            />
            <path
              d="M107.927 27.303C108.684 27.7648 110.254 28.3074 111.472 28.3074C112.718 28.3074 113.232 27.8745 113.232 27.1991C113.232 26.518 112.828 26.2005 111.281 25.681C108.545 24.7574 107.489 23.2681 107.518 21.698C107.518 19.2389 109.63 17.3687 112.903 17.3687C114.444 17.3687 115.83 17.7208 116.638 18.1248L115.911 20.9707C115.316 20.6474 114.179 20.2087 113.036 20.2087C112.037 20.2087 111.466 20.6185 111.466 21.2939C111.466 21.9116 111.985 22.2406 113.602 22.8121C116.124 23.6779 117.181 24.9479 117.204 26.899C117.204 29.358 115.253 31.1763 111.466 31.1763C109.734 31.1763 108.187 30.7954 107.188 30.2585L107.927 27.303Z"
              fill="#808082"
            />
            <path
              d="M131.912 24.1397C131.912 28.9828 128.471 31.1994 124.927 31.1994C121.054 31.1994 118.081 28.6538 118.081 24.3822C118.081 20.1048 120.892 17.3687 125.147 17.3687C129.205 17.3687 131.912 20.1567 131.912 24.1397ZM122.33 24.2725C122.33 26.5468 123.276 28.2555 125.037 28.2555C126.636 28.2555 127.663 26.6565 127.663 24.2725C127.663 22.2983 126.907 20.2953 125.037 20.2953C123.063 20.2953 122.33 22.3214 122.33 24.2725Z"
              fill="#808082"
            />
            <path
              d="M146.504 11.6829V26.9452C146.504 28.4345 146.561 29.9988 146.613 30.8936H142.959L142.775 28.954H142.717C141.88 30.4433 140.281 31.1995 138.572 31.1995C135.432 31.1995 132.915 28.5269 132.915 24.4053C132.886 19.9375 135.674 17.3687 138.844 17.3687C140.471 17.3687 141.741 17.9402 142.336 18.8522H142.394V11.6829H146.504ZM142.394 23.2682C142.394 23.0546 142.359 22.7544 142.336 22.5351C142.093 21.4267 141.199 20.5089 139.929 20.5089C138.064 20.5089 137.089 22.1887 137.089 24.2726C137.089 26.5123 138.197 27.9265 139.906 27.9265C141.095 27.9265 142.047 27.1126 142.29 25.9466C142.371 25.658 142.399 25.3578 142.399 24.9999V23.2682H142.394Z"
              fill="#808082"
            />
            <path
              d="M152.034 17.6633L154.014 24.1631C154.227 24.9424 154.498 25.9179 154.66 26.6222H154.741C154.931 25.9179 155.145 24.9193 155.335 24.1631L156.963 17.6633H161.373L158.285 26.3797C156.392 31.6326 155.122 33.7396 153.627 35.0673C152.189 36.3083 150.677 36.7413 149.65 36.8798L148.784 33.3817C149.297 33.3067 149.95 33.0584 150.567 32.6775C151.191 32.3542 151.866 31.7019 152.276 31.0323C152.409 30.8418 152.49 30.6225 152.49 30.4378C152.49 30.305 152.461 30.0856 152.305 29.7624L147.456 17.6633H152.034Z"
              fill="#808082"
            />
          </svg>
        </Box>
      </Box>
      <Box classes="docDetailModal-body mobile">
        <svg
          width="370"
          height="445"
          viewBox="0 0 370 445"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_0_1)">
            <rect
              width="226.858"
              height="226.858"
              rx="5"
              transform="matrix(0.771305 -0.636465 0.771305 0.636465 9.74023 154.523)"
              fill="white"
            />
          </g>
          <rect
            width="226.858"
            height="226.858"
            rx="32"
            transform="matrix(0.771305 -0.636465 0.771305 0.636465 9.74023 145.973)"
            fill="white"
          />
          <path
            d="M15.9963 140.803L16.2866 151.368L101.42 221.618L117.702 208.183L79.5466 176.698L78.4574 175.799L69.3923 168.319L63.9426 163.822L62.8535 162.923L41.6221 145.403L40.5329 144.505L41.5738 143.646L80.5017 111.523L65.9907 99.5491L15.9963 140.803Z"
            fill="url(#paint0_linear_452_160513)"
            fill-opacity={hover > 0 ? "1" : "0.25"}
          />
          <path
            d="M178.566 286.014L191.369 285.775L276.502 215.524L260.22 202.089L222.065 233.574L220.976 234.473L211.911 241.953L206.461 246.45L205.372 247.349L184.141 264.869L183.052 265.767L182.011 264.908L143.083 232.786L128.572 244.76L178.566 286.014Z"
            fill="url(#paint0_linear_452_160514)"
            fill-opacity={hover > 0 ? "1" : "0.25"}
          />
          <path
            d="M190.817 6.74734L178.014 6.98691L92.8807 77.2373L109.162 90.6726L147.318 59.1877L148.407 58.289L157.472 50.8086L162.922 46.3117L164.011 45.4129L185.242 27.8932L186.331 26.9944L187.372 27.8534L226.3 59.9758L240.811 48.0017L190.817 6.74734Z"
            fill="url(#paint0_linear_452_160515)"
            fill-opacity={hover > 0 ? "1" : "0.25"}
          />
          <path
            d="M353.793 151.38L353.502 140.816L268.369 70.5655L252.087 84.0008L290.242 115.486L291.332 116.384L300.397 123.865L305.846 128.362L306.936 129.26L328.167 146.78L329.256 147.679L328.215 148.538L289.287 180.66L303.798 192.634L353.793 151.38Z"
            fill="url(#paint0_linear_452_160516)"
            fill-opacity={hover > 0 ? "1" : "0.25"}
          />

          <rect
            width="205.038"
            height="205.038"
            transform="matrix(0.771305 -0.636465 0.771305 0.636465 26.5703 145.973)"
            fill="white"
          />
          {actionList.includes("VIEW") && actionList.includes("DOWNLOAD") && (
            <>
              <g
                filter="url(#filter1_d_0_1)"
                onMouseEnter={(e) => setHover(7)}
                onMouseLeave={(e) => setHover(0)}
                onTouchStart={(e) => setHover(7)}
                onTouchEnd={(e) => setHover(0)}
                className="docDetailModal-body-hand"
                onClick={btnActions["DOWNLOAD"].action}
              >
                <rect
                  width="76.1531"
                  height="76.1531"
                  rx="5"
                  transform="matrix(0.770925 -0.636927 0.770925 0.636927 208.42 389.233)"
                  fill={"white"}
                />
              </g>
              <g
                filter="url(#filter2_d_0_1)"
                onMouseEnter={(e) => setHover(7)}
                onMouseLeave={(e) => setHover(0)}
                onTouchStart={(e) => setHover(7)}
                onTouchEnd={(e) => setHover(0)}
                className="docDetailModal-body-hand"
                onClick={btnActions["DOWNLOAD"].action}
              >
                <rect
                  width="76.1531"
                  height="76.1531"
                  rx="5"
                  transform="matrix(0.770925 -0.636927 0.770925 0.636927 208.42 377.106)"
                  fill={hover === 7 ? "#05C072" : "white"}
                />
                {getIcon(
                  getX(7, "ICON"),
                  getY(7, "ICON"),
                  hover === 7
                    ? "white"
                    : getColor("COLOR_ICON_INTERACTIVE_BRAND_DISABLED"),
                  "DOWNLOAD"
                )}
                {textLabel(
                  getX(7, "LABEL"),
                  getY(7, "LABEL"),
                  hover === 7 ? "white" : getColor("COLOR_TEXT_PRIMARY"),
                  btnActions["DOWNLOAD"].title
                )}
              </g>
            </>
          )}
          {actionList.includes("VIEW") && actionList.includes("DOWNLOAD") ? (
            <>
              <g
                filter="url(#filter3_d_0_1)"
                onMouseEnter={(e) => setHover(6)}
                onMouseLeave={(e) => setHover(0)}
                onTouchStart={(e) => setHover(6)}
                onTouchEnd={(e) => setHover(0)}
                className="docDetailModal-body-hand"
                onClick={btnActions["VIEW"].action}
              >
                <rect
                  width="76.1531"
                  height="76.1531"
                  rx="5"
                  transform="matrix(0.770925 -0.636927 0.770925 0.636927 44.8203 389.233)"
                  fill="white"
                />
              </g>
              <g
                filter="url(#filter4_d_0_1)"
                onMouseEnter={(e) => setHover(6)}
                onMouseLeave={(e) => setHover(0)}
                onTouchStart={(e) => setHover(6)}
                onTouchEnd={(e) => setHover(0)}
                className="docDetailModal-body-hand"
                onClick={btnActions["VIEW"].action}
              >
                <rect
                  width="76.1531"
                  height="76.1531"
                  rx="5"
                  transform="matrix(0.770925 -0.636927 0.770925 0.636927 44.8203 377.106)"
                  fill={hover === 6 ? "#05C072" : "white"}
                />
                {getIcon(
                  getX(6, "ICON"),
                  getY(6, "ICON"),
                  hover === 6
                    ? "white"
                    : getColor("COLOR_ICON_INTERACTIVE_BRAND_DISABLED"),
                  "VIEW"
                )}
                {textLabel(
                  getX(6, "LABEL"),
                  getY(6, "LABEL"),
                  hover === 6 ? "white" : getColor("COLOR_TEXT_PRIMARY"),
                  btnActions["VIEW"].title
                )}
              </g>
            </>
          ) : (
            (actionList.includes("VIEW") ||
              actionList.includes("DOWNLOAD")) && (
              <>
                <g
                  filter="url(#filter5_d_0_1)"
                  onMouseEnter={(e) => setHover(8)}
                  onMouseLeave={(e) => setHover(0)}
                  onTouchStart={(e) => setHover(8)}
                  onTouchEnd={(e) => setHover(0)}
                  onClick={
                    btnActions[
                      actionList.includes("VIEW") ? "VIEW" : "DOWNLOAD"
                    ].action
                  }
                  className="docDetailModal-body-hand"
                >
                  <rect
                    width="76.1531"
                    height="76.1531"
                    rx="5"
                    transform="matrix(0.770925 -0.636927 0.770925 0.636927 125.395 389.234)"
                    fill="white"
                  />
                </g>
                <g
                  filter="url(#filter6_d_0_1)"
                  onMouseEnter={(e) => setHover(8)}
                  onMouseLeave={(e) => setHover(0)}
                  onTouchStart={(e) => setHover(8)}
                  onTouchEnd={(e) => setHover(0)}
                  onClick={
                    btnActions[
                      actionList.includes("VIEW") ? "VIEW" : "DOWNLOAD"
                    ].action
                  }
                  className="docDetailModal-body-hand"
                >
                  <rect
                    width="76.1531"
                    height="76.1531"
                    rx="5"
                    transform="matrix(0.770925 -0.636927 0.770925 0.636927 125.395 377.107)"
                    fill={hover === 8 ? "#05C072" : "white"}
                  />
                  {getIcon(
                    getX(8, "ICON"),
                    getY(8, "ICON"),
                    hover === 8
                      ? "white"
                      : getColor("COLOR_ICON_INTERACTIVE_BRAND_DISABLED"),
                    actionList.includes("VIEW") ? "VIEW" : "DOWNLOAD"
                  )}
                  {textLabel(
                    getX(8, "LABEL"),
                    getY(8, "LABEL"),
                    hover === 8 ? "white" : getColor("COLOR_TEXT_PRIMARY"),
                    btnActions[
                      actionList.includes("VIEW") ? "VIEW" : "DOWNLOAD"
                    ].title
                  )}
                </g>
              </>
            )
          )}
          <defs>
            <filter
              id="filter0_d_0_1"
              x="0"
              y="0"
              width="369.436"
              height="309.047"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="6" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0196078 0 0 0 0 0.752941 0 0 0 0 0.447059 0 0 0 0.5 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_0_1"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_0_1"
                result="shape"
              />
            </filter>
            <filter
              id="filter1_d_0_1"
              x="201.678"
              y="333.595"
              width="130.9"
              height="111.277"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="4.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0196078 0 0 0 0 0.752941 0 0 0 0 0.447059 0 0 0 0.5 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_0_1"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_0_1"
                result="shape"
              />
            </filter>
            <filter
              id="filter2_d_0_1"
              x="201.678"
              y="321.468"
              width="130.9"
              height="111.277"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="4.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0196078 0 0 0 0 0.752941 0 0 0 0 0.447059 0 0 0 0.5 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_0_1"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_0_1"
                result="shape"
              />
            </filter>
            <filter
              id="filter3_d_0_1"
              x="38.0781"
              y="333.595"
              width="130.9"
              height="111.277"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="4.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0196078 0 0 0 0 0.752941 0 0 0 0 0.447059 0 0 0 0.5 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_0_1"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_0_1"
                result="shape"
              />
            </filter>
            <filter
              id="filter4_d_0_1"
              x="38.0781"
              y="321.468"
              width="130.9"
              height="111.277"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="4.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0196078 0 0 0 0 0.752941 0 0 0 0 0.447059 0 0 0 0.5 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_0_1"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_0_1"
                result="shape"
              />
            </filter>
            <filter
              id="filter5_d_0_1"
              x="118.652"
              y="333.596"
              width="130.9"
              height="111.277"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="4.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0196078 0 0 0 0 0.752941 0 0 0 0 0.447059 0 0 0 0.5 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_0_1"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_0_1"
                result="shape"
              />
            </filter>
            <filter
              id="filter6_d_0_1"
              x="118.652"
              y="321.469"
              width="130.9"
              height="111.277"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="4.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0196078 0 0 0 0 0.752941 0 0 0 0 0.447059 0 0 0 0.5 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_0_1"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_0_1"
                result="shape"
              />
            </filter>
            <linearGradient
              id="paint0_linear_0_1"
              x1="37.8655"
              y1="122.757"
              x2="112.142"
              y2="212.77"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#05C072" />
              <stop offset="1" stop-color="white" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_0_1"
              x1="156.697"
              y1="267.968"
              x2="230.974"
              y2="177.955"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#05C072" />
              <stop offset="1" stop-color="white" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_0_1"
              x1="212.686"
              y1="24.7933"
              x2="138.409"
              y2="114.806"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#05C072" />
              <stop offset="1" stop-color="white" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_0_1"
              x1="331.924"
              y1="169.426"
              x2="257.647"
              y2="79.4132"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#05C072" />
              <stop offset="1" stop-color="white" />
            </linearGradient>{" "}
            <linearGradient
              id="paint0_linear_452_160513"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
              gradientUnits="objectBoundingBox"
            >
              <stop stop-color="#05C072" />
              <stop offset="1" stop-color="white" />
            </linearGradient>
            <linearGradient
              id="paint0_linear_452_160514"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
              gradientUnits="objectBoundingBox"
            >
              <stop stop-color="#05C072" />
              <stop offset="1" stop-color="white" />
            </linearGradient>
            <linearGradient
              id="paint0_linear_452_160515"
              x1="100%"
              y1="100%"
              x2="0%"
              y2="0%"
              gradientUnits="objectBoundingBox"
            >
              <stop stop-color="#05C072" />
              <stop offset="1" stop-color="white" />
            </linearGradient>
            <linearGradient
              id="paint0_linear_452_160516"
              x1="100%"
              y1="100%"
              x2="0%"
              y2="0%"
              gradientUnits="objectBoundingBox"
            >
              <stop stop-color="#05C072" />
              <stop offset="1" stop-color="white" />
            </linearGradient>
          </defs>
        </svg>
        <Box
          direction="column"
          classes="docDetailModal-outBox"
          height={270}
          // alignItems="center"
        >
          <Box
            classes="docDetailModal-outBox-in"
            direction="column"
            alignItems="center"
          >
            {utilsDocs.renderDocIcon(simpleInfo.contentName, 40)}
            <Tooltip
              message={simpleInfo.contentName}
              classes="mg mt-10"
              maxWidth={230}
            >
              <Typography ellipsis type="subtitle1">
                {simpleInfo.contentName}
              </Typography>
            </Tooltip>
            <Typography
              type="caption_rg"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
              classes="mg mt-4"
            >
              {utilsDocs.fileSizeFormat(simpleInfo.fileSize)}
            </Typography>
            <Box alignItems="center" classes="mg mt-8">
              <Typography
                type="caption_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("file.master")}:
              </Typography>
              <Tooltip
                classes="mg ml-8"
                message={utilsCommon.getUserNameIdTag(
                  simpleInfo.master.userId,
                  simpleInfo.master.userName
                )}
                maxWidth={105}
              >
                <Typography type="caption_rg" whiteSpace="pre" ellipsis>
                  {utilsCommon.getUserNameIdTag(
                    simpleInfo.master.userId,
                    simpleInfo.master.userName
                  )}
                </Typography>
              </Tooltip>
            </Box>
            {!!documentInfo?.documentInfo.myPolicy?.policy?.allowDays &&
              ![9999999999999, -1, 0].includes(
                documentInfo?.documentInfo.myPolicy?.policy?.allowDays
              ) && (
                <Box classes="mg mt-8">
                  <Typography
                    type="caption_rg"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                    // classes="mg ml-16"
                  >
                    {`${t("file.policy.viewExpiration")}:`}
                  </Typography>
                  <Box
                    direction={i18n.language.includes("ko") ? "row" : "column"}
                    // alignItems="center"
                    classes="mg ml-8"
                  >
                    <Typography
                      type="caption_rg"
                      whiteSpace="pre"
                      exactColor={
                        isExpired.policy
                          ? getColor("COLOR_TEXT_ERROR")
                          : getColor("COLOR_TEXT_PRIMARY")
                      }
                    >
                      {utilsCommon.renderDateFormat(
                        dayjs(
                          documentInfo?.documentInfo.myPolicy.targetType ===
                            "USER"
                            ? documentInfo?.documentInfo.myPolicy.policy
                                ?.startTime
                              ? documentInfo?.documentInfo.myPolicy.policy
                                  .startTime
                              : undefined
                            : documentInfo?.documentInfo?.createTime ??
                                undefined
                        )
                          .add(
                            documentInfo?.documentInfo.myPolicy?.policy
                              ?.allowDays
                              ? documentInfo?.documentInfo.myPolicy?.policy
                                  ?.allowDays - 1
                              : 0,
                            "day"
                          )
                          .set("hour", 23)
                          .set("minute", 59)
                          .valueOf(),
                        "YYYY-MM-DD"
                      )}
                    </Typography>
                    <Box>
                      <Typography
                        type="caption_rg"
                        classes={classNames({
                          "mg ml-2": i18n.language.includes("ko"),
                        })}
                        whiteSpace="pre"
                        exactColor={
                          isExpired.policy
                            ? getColor("COLOR_TEXT_ERROR")
                            : getColor("COLOR_TEXT_PRIMARY")
                        }
                      >
                        {`(GMT+${serverTimezone})`}
                      </Typography>
                      <Typography
                        type="caption_rg"
                        classes={"mg ml-2"}
                        whiteSpace="pre"
                        exactColor={
                          isExpired.policy
                            ? getColor("COLOR_TEXT_ERROR")
                            : getColor("COLOR_TEXT_PRIMARY")
                        }
                      >
                        {isExpired.policy && `(${t("file.expired")})`}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )}

            {loginState.actionInfo.authType !== "LOGIN" &&
              !!loginState.actionInfo.expiredTime &&
              ![9999999999999, -1, 0].includes(
                loginState.actionInfo.expiredTime
              ) && (
                <Box classes="mg mt-8">
                  <Typography
                    type="caption_rg"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                  >
                    {t("file.linkExpiration")}:
                  </Typography>
                  <Box direction="column">
                    <Typography
                      type="caption_rg"
                      classes="mg ml-8"
                      whiteSpace="pre"
                      exactColor={
                        isExpired.link
                          ? getColor("COLOR_TEXT_ERROR")
                          : getColor("COLOR_TEXT_PRIMARY")
                      }
                    >
                      {utilsCommon.renderDateFormat(
                        dayjs(loginState.actionInfo.expiredTime).valueOf(),
                        "YYYY-MM-DD",
                        "",
                        true
                      )}
                    </Typography>
                    <Box>
                      <Typography
                        type="caption_rg"
                        classes={classNames({
                          "mg ml-2": i18n.language.includes("ko"),
                        })}
                        whiteSpace="pre"
                        exactColor={
                          isExpired.policy
                            ? getColor("COLOR_TEXT_ERROR")
                            : getColor("COLOR_TEXT_PRIMARY")
                        }
                      >
                        {`(GMT+${serverTimezone})`}
                      </Typography>
                      {isExpired.link && (
                        <Typography
                          type="caption_rg"
                          classes={"mg ml-2"}
                          whiteSpace="pre"
                          exactColor={
                            isExpired.link
                              ? getColor("COLOR_TEXT_ERROR")
                              : getColor("COLOR_TEXT_PRIMARY")
                          }
                        >
                          {`(${t("file.expired")})`}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>
              )}
          </Box>
        </Box>
      </Box>
    </Box>
  ) : (
    <Progress inProgress />
  );
};

export default NewWebusingLink;
